var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-secondary-dark p-4 flex justify-between items-center rounded"},[_c('p',{staticClass:"text-white"},[_vm._t("default")],2),_c('Button',{attrs:{"color":"primary"}},[_vm._v("Upgrade Now")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }